// Vocabularies the server validates against. Keep these in step with
// crm_server/writes.py (CALL_OUTCOMES, CONSENT_BASES) and the LOS enums.

export const LEAD_STATUSES = [
  { key: 'new', label: 'New' },
  { key: 'assigned', label: 'Assigned' },
  { key: 'contacted', label: 'Contacted' },
  { key: 'appointment', label: 'Appointment' },
  { key: 'application', label: 'Application' },
  { key: 'funded', label: 'Funded' },
  { key: 'dead', label: 'Dead' },
] as const

export const CALL_OUTCOMES = [
  { key: 'connected', label: 'Connected' },
  { key: 'no_answer', label: 'No answer' },
  { key: 'voicemail', label: 'Left voicemail' },
  { key: 'wrong_number', label: 'Wrong number' },
  { key: 'booked', label: 'Appointment booked' },
] as const

/** How TCPA consent to text was obtained. An officer must pick one to record it. */
export const CONSENT_BASES = [
  { key: 'express_written', label: 'Express written consent on file' },
  { key: 'prior_express', label: 'Borrower gave this number for their loan' },
  { key: 'inbound', label: 'They texted or called us first' },
] as const

export const PURPOSES = [
  { key: 'purchase', label: 'Purchase' },
  { key: 'cash_out_refinance', label: 'Cash-out refinance' },
  { key: 'no_cash_out_refinance', label: 'Rate/term refinance' },
  { key: 'construction', label: 'Construction' },
  { key: 'construction_permanent', label: 'Construction-permanent' },
  { key: 'other', label: 'Other' },
] as const

export const LOAN_TYPES = [
  { key: 'conventional', label: 'Conventional' },
  { key: 'fha', label: 'FHA' },
  { key: 'va', label: 'VA' },
  { key: 'usda_rural_housing', label: 'USDA' },
  { key: 'heloc', label: 'HELOC' },
  { key: 'heloan', label: 'Home equity loan' },
  { key: 'other', label: 'Other' },
] as const
